<template>
  <div class="container">
    {{formItem.title}}
    <span class="info-arrow" @click="goLink"></span>
  </div>
</template>
<script>
export default {
  props: ["formItem", "idx"],
  methods: {
    goLink() {
      if (this.formItem.link) {
        location.href = this.formItem.link;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 1.4rem;
  padding-right: 0.36rem;
  margin-bottom: 0.1rem;
  font-size: 0.36rem;
  color: #414141;
  background: #fff;
}
</style>

